export const iconFontAwesomeMusicVideoMusic = (
	<i className="fa-solid fa-music"></i>
);
